/**
 * Dateの日付をyyyy-mm-dd形式のDateに変換する
 * @param inputDate Date
 * @returns Date yyyy-mm-dd型のDate
 */
export const fromDateToFullYearMonthDate = (inputDate: Date): Date => {
  const stringDate = `${inputDate.getFullYear()}-${inputDate.getMonth() + 1}-${inputDate.getDate()}`;
  return new Date(stringDate);
};
